import React, { useEffect, useContext } from "react"; // ✅ Added useContext
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; // ✅ Added useLocation
import { ToastContainer } from "react-toastify";
import LoginForm from "./components/Login";
import Dashboard from "./components/Dashboard/dashboard";
import AdminUserRoutes from "./Routing/AdminUserRoutes";
import AdminDashboard from "./components/Admin/Admin";
import Screening from "./components/Screening/screening";
import withAuth from "./services/withAuth";
import DeleteUserAct from "./components/Admin/delete-user-account";
import { LoaderContext } from "./services/loadercontext"; // ✅ Ensure this path is correct
import Loader from "./components/loader";
import PCMainContent from "./components/ProgramCoordinator/PCMainContent";

function App() {
  return (
    <>
      <Loader />
      <AppRoutes />
      <ToastContainer /> {/* Required for displaying toasts */}
    </>
  );
}

function AppRoutes() {
  const { setLoading } = useContext(LoaderContext);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500); // Simulate a small delay
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<AdminUserRoutes />} />
      <Route path="/Admin/*" element={<AdminUserRoutes />} />
      <Route path="/admin-dashboard/*" element={<AdminDashboard />} />
      <Route path="/PC/*" element={<PCMainContent />} />
      <Route path="/screening" element={<Screening />} />
      <Route path="/delete-user-account" element={<DeleteUserAct />} />
    </Routes>
  );
}

export default App;
